// @flow

import React, { type ComponentType } from "react";
import { connect } from "react-redux";

import * as settingSelectors from "@modules/settings/selectors";
import actionCreators from "@modules/settings/actionCreator";
import type { State } from "@store/reducers";
import type { Settings } from "@modules/settings/types";

export type PropsFromSettings = $Exact<{
  settings: Settings,
}>;

type PropsFromState = $Exact<{
  settings: ?Settings,
}>;

type PropsFromDispatch = $Exact<{
  getSettings: typeof actionCreators.GetSettings,
}>;

type OwnProps = $Exact<{
  clientId: ?number,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

const withSettings = (props?: OwnProps) => {
  return (WrappedComponent: ComponentType<any>) => {
    class WithSettings extends React.Component<Props> {
      componentDidMount() {
        if (this.props.clientId) {
          this.props.getSettings({ clientId: this.props.clientId });
        }
      }

      componentDidUpdate(prevProps: Props) {
        if (this.props.clientId && this.props.clientId !== prevProps.clientId) {
          this.props.getSettings({ clientId: this.props.clientId });
        }
      }

      render() {
        return <WrappedComponent {...this.props} settings={this.props.settings} />;
      }
    }

    const mapStateToProps = (state: State): PropsFromState => {
      return {
        settings: settingSelectors.getSettings(state),
      };
    };

    const mapDispatchToProps: PropsFromDispatch = {
      getSettings: actionCreators.GetSettings,
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithSettings);
  };
};

export default withSettings;
